import {bindActionCreators} from 'redux'
import {connect} from '../../redux/utils'
import View from '../../View'
import BulkOperationsPanel from './components/BulkOperationsPanel'
import AnimatedVisibilityContainer from '../../util/AnimatedVisibilityContainer'
import {
    getBulkAssignDialogData,
    getBulkChangeStatusDialogData,
    getBulkMoveDialogData,
    getBulkOperationsPanelState,
    getBulkTaskDeleteDialogData,
    getCurrentOperation,
    isProcessingBulkOperation,
    isShowPanel,
} from './selectors'
import {setBulkOperationsPanelShownState} from '../common/actions'
import {
    changeBulkAssignDialogSelection,
    changeTasksAssignmentsAction,
    changeTasksStatusAction,
    cleanupDialogsDataAction,
    copyTasksAction,
    deleteTasksAction,
    moveTasksAction,
    startBulkAssignAction,
    startBulkChangeTasksStatusAction,
    startBulkCopyOperation,
    startBulkMoveAction,
    startBulkTasksDeleteAction,
} from './actions'
import {BulkOperationType} from './constants'
import $ from "jquery"
import LoadingContainer from "../../util/LoadingContainer"
import messageResource from "../../messageResource"
import DeleteTasksConfirmationDialog from "../../cptManagement/deleteConfirmationDialog/DeleteTasksConfirmationDialog"
import DialogWithPointerWrapper from "../tasksTable/DialogWithPointerWrapper"
import AssignTasksToDialog from "./components/AssignTasksToDialog"
import ChangeTasksStatusDialog from "./components/ChangeTasksStatusDialog"
import {HIDE_ANIMATION_CLASSES, SHOW_ANIMATION_CLASSES} from "../../panels/constants"
import {
    canViewerEditTaskStatus,
    getCustomerIdsWhereCanManageLeastOneProject,
    getEditableCustomerIds,
    getEditableProjectIds,
    getEditableProjectIdsWithExcludeSelf,
    getRecentlyCreatedTaskIds,
    isViewerHasNoTeamAccess
} from '../common/selectors'
import MoveToDialog from '../../panels/MoveToDialog'
import InformationBlock from '../../components/informationBlock/InformationBlock'
import {canAccessSomeTeamAssignment, canManageAccountsAndPermissions, getLoggedInUserId} from '../../loggedInUser/selectors'
import {clearTaskSelectionAction, loadExistingTaskIdsAction} from '../taskSelection/actions'
import {isEsc, KEY_HANDLERS} from '../../keyHandlers'
import {isBTYEnabled, isESTEnabled, isTWSEnabled, isWASEnabled} from '../../features/selectors'
import CopySettingsBlock from '../../panels/components/CopySettingsBlock'
import {getItemsForCopyTaskSettingsBlock} from '../../panels/components/utils'
import {getSelectedTaskIdsArray} from '../taskSelection/selectors'
import {BulkMoveTypes} from 'constants'
import MoveToArchivedConfirmationDialog from '../../panels/MoveToArchivedConfirmationDialog'
import {getFirstCompletedWorkflowStatus} from '../../workflowStatus/selectors'

class Container extends View {
    constructor({
        $pageEl,
        $dialogsContainerEl,
        $containerEl,
        clearTaskSelectionAction = () => {},
        loadExistingTaskIdsCountAction = () => {},
        startBulkTasksDeleteAction = () => {},
        startBulkMoveAction = () => {},
        moveTasksAction = () => {},
        startBulkCopyOperation = () => {},
        copyTasksAction = () => {},
        deleteTasksAction = () => {},
        startBulkAssignAction = () => {},
        startBulkChangeTasksStatusAction = () => {},
        changeTasksStatusAction = () => {},
        changeTasksAssignmentsAction = () => {},
        cleanupDialogsDataAction = () => {},
        setBulkOperationsPanelShownStateAction = () => {},
        changeBulkAssignDialogSelection = () => {},
    }) {
        super(null)

        this.state = {
            existingTasksCount: 0,
            selectedTasksCount: 0,

            loading: false,
            showPanel: false,

            operationProcessing: false,
            currentOperation: null,
            deleteDialogData: {
                loading: false,
                defaultWorkflowStatusId: -1,
            },
            assignToDialogData: {
                loading: false,
                numberOfTasks: 0,
                canModifyAny: true,
                timeZoneGroups: [],
                timeZoneGroupsEnabled: false,
                userGroups: [],
                userGroupsEnabled: false,
                users: [],
                selectedUserIds: [],
                userRatesEnabled: false,
                billingTypesEnabled: false,
            },
            changeStatusDialogData: {
                loading: false,
            },
            moveDialogData: {
                loading: false,
                taskIds: [],
                notAvailableToMoveTasks: [],
                includeOpenTasks: true,
            },
            copyDialogTaskIds: [],

            recentlyCreatedTaskIds: {},
            moveAndCopySelectorsCustomerIds: {},
            moveAndCopySelectorsProjectIds: {},
            noTeamAccess: false,
            loggedInUserId: -1,

            isWASEnabled: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,

            editableCustomersIds: {},
            editableProjectsIds: {},

            canManageAccountsAndPermissions: false,
            canEditTaskStatus: true,
            hasSomeTeamAssignment: false,

            defaultCompletedStatus: {},
        }

        this.params = {
            $pageEl,
            $dialogsContainerEl,
            $containerEl
        }

        this.actions = {
            clearTaskSelectionAction,
            loadExistingTaskIdsCountAction,
            startBulkTasksDeleteAction,
            startBulkMoveAction,
            moveTasksAction,
            startBulkCopyOperation,
            copyTasksAction,
            deleteTasksAction,
            startBulkAssignAction,
            startBulkChangeTasksStatusAction,
            changeTasksStatusAction,
            changeTasksAssignmentsAction,
            cleanupDialogsDataAction,
            setBulkOperationsPanelShownStateAction,
            changeBulkAssignDialogSelection,
        }

        this.onStatePropertyChanged('loading', (loading) => {
            this.bulkOperationsPanelContainer.setState({
                loading: loading
            })
        })

        this.onStatePropertyChanged('isWASEnabled', (wasFeatureEnabled) => {
            this.bulkOperationsPanelContainer.setState({
                assignToButtonVisible: wasFeatureEnabled,
            })

            this._updateDialogsInfo()
        })

        this.onStatePropertyChanged('showPanel', (show, prevShow) => {
            this.bulkOperationsPanelContainer.setState({
                visible: show
            })

            if (prevShow !== show) {
                // is show add handler if hide - only remove
                this._toggleOnEscHandler(show)
                if (!show) {
                    this.actions.cleanupDialogsDataAction()
                }
            }
        })

        // handle counters after handling `showPanel`
        this.onAnyStatePropertyChanged(['selectedTasksCount', 'existingTasksCount'], (state) => {
            const {selectedTasksCount, existingTasksCount} = state
            this.bulkOperationsPanelContainer.setState({
                empty: existingTasksCount === 0,
                selectedTasksCount,
                existingTasksCount,
            })
        })

        this.onAnyStatePropertyChanged(['moveAndCopySelectorsProjectIds', 'moveAndCopySelectorsCustomerIds'], (state) => {
            this.moveToDialog.setCustomersToMove(state.moveAndCopySelectorsCustomerIds)
            this.moveToDialog.setProjectsToMove(state.moveAndCopySelectorsProjectIds)
            this.copyToDialog.setCustomersToMove(state.moveAndCopySelectorsCustomerIds)
            this.copyToDialog.setProjectsToMove(state.moveAndCopySelectorsProjectIds)
        })

        this.onAnyStatePropertyChanged(['canManageAccountsAndPermissions', 'isBTYEnabled', 'isESTEnabled',
                                               'isTWSEnabled', 'isWASEnabled', 'hasSomeTeamAssignment'], () => {
            this.copySettingsBlock.setState(getItemsForCopyTaskSettingsBlock(this.state.canManageAccountsAndPermissions,
                this.state.isBTYEnabled,
                this.state.isESTEnabled,
                this.state.isTWSEnabled,
                this.state.isWASEnabled,
                this.state.hasSomeTeamAssignment,
                )
            )
        })

        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => this.archivingConfirmation.setState(
            {
                isTWSEnabled: isTWSEnabled,
                archiveText: isTWSEnabled
                    ? messageResource.getMessage('task.list.move_to.bulk.confirm_archive.complete_with_status')
                    : messageResource.getMessage('task.list.move_to.bulk.confirm_archive.complete_feature_disabled'),
            }
        ))

        this.onStatePropertyDeeplyChanged('noTeamAccess', (noTeamAccess) => {
            this.bulkOperationsPanelContainer.setState({
                assignToButtonDisabled: noTeamAccess,
            })
        })

        this.onStatePropertyChanged('canEditTaskStatus', (canEditTaskStatus) => {
            this.bulkOperationsPanelContainer.setState({
                changeStatusButtonVisible: canEditTaskStatus
            })

            this.archivingConfirmation.setState({
                canEditTaskStatus
            })
        })

        this.onStateChanged((state, prevState) => {
            this._handleOperationDialogs(state, prevState)
        })
    }

    init() {
        super.init(this.params.$containerEl)

        this.bulkOperationsPanel = new BulkOperationsPanel({
            onChangeStatusClick: this._handleOnChangeStatusClick,
            onDeleteClick: this._handleOnDeleteClick,
            onClearSelectionClick: this.actions.clearTaskSelectionAction,
            onAssignToClick: this._handleOnAssignToClick,
            onMoveToClick: this._handleOnMoveToClick,
            onCopyToClick: this._handleOnCopyToClick,
        })

        this.bulkOperationsPanelContainer = new AnimatedVisibilityContainer({
            $containerEl: this.params.$containerEl,
            containerClass: "tasklist_components_bulkOperationsPanelContainer",
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_UP,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_UP,
            contentComponent: new LoadingContainer({
                showAnimated: false,
                hideAnimated: false,
                contentComponent: this.bulkOperationsPanel,
            }),
            onShowCb: () => this.actions.setBulkOperationsPanelShownStateAction(true),
            onHideCb: () => this.actions.setBulkOperationsPanelShownStateAction(false),
        }).init()

        this.deleteTasksDialog = new DialogWithPointerWrapper(
            this.params.$dialogsContainerEl,
            this.params.$pageEl,
            {
                className: 'deleteDialog',
                dialog: new DeleteTasksConfirmationDialog(
                    null,
                    () => this.deleteTasksDialog.hide(),
                    this.actions.deleteTasksAction,
                ),
                dialogType: BulkOperationType.DELETE,
            }
        ).init()

        this.assignToDialog = new DialogWithPointerWrapper(
            this.params.$dialogsContainerEl,
            this.params.$pageEl,
            {
                className: "assignToDialog tasksChangeDialog",
                dialog: new AssignTasksToDialog({
                    $containerElement: $(".assignToDialog .content"),
                    cancelHandler: () => {
                        this.assignToDialog.hide()
                    },
                    submitHandler: (userIds) => {
                        this.actions.changeTasksAssignmentsAction(userIds)
                    },
                    selectionChangedCb: (addedUserIds, removedUserIds) => {
                        this.actions.changeBulkAssignDialogSelection(addedUserIds, removedUserIds)
                    },
                }),
                dialogType: BulkOperationType.CHANGE_ASSIGNMENTS,
            }
        ).init()

        this.changeTasksStatusDialog = new DialogWithPointerWrapper(
            this.params.$dialogsContainerEl,
            this.params.$pageEl,
            {
                className: "changeTasksStatusDialog tasksChangeDialog",
                dialog: new ChangeTasksStatusDialog({
                    $containerElement: $(".changeTasksStatusDialog .content"),
                    defaultWorkflowStatusId: -1,
                    cancelHandler: () => {
                        this.changeTasksStatusDialog.hide()
                    },
                    submitHandler: (workflowStatusId) => {
                        this.actions.changeTasksStatusAction(workflowStatusId)
                    },
                }),
                dialogType: BulkOperationType.CHANGE_STATUS,
            }).init()

        this._initMoveTasksDialog()
        this._initCopyTasksDialog()
    }

    _initMoveTasksDialog() {
        this.moveTaskDialogInfoBlock = new InformationBlock({
            title: messageResource.getMessage('task.list.move_to.task.info_title'),
        })

        this.moveToDialog = new MoveToDialog({
            mode: MoveToDialog.Mode.CUSTOMER_PROJECT,
            titleMessageKey: "task.list.move_to.task.title",
            buttonMessageKey: "edit_panel.action.move",
            onMoveCb: this._handleMoveTo,
            onCancelCb: () => this.moveTasksDialog.hide(),
            infoBlock: this.moveTaskDialogInfoBlock,
        })
        this.moveToDialog.setState({showArchived: true})

        this.moveTasksDialog = new DialogWithPointerWrapper(
            this.params.$dialogsContainerEl,
            this.params.$pageEl,
            {
                className: 'moveDialog',
                dialog: this.moveToDialog,
                dialogType: BulkOperationType.MOVE,
            }
        ).init()

        this._initMoveToArchiveConfirmationDialog()
    }

    _initMoveToArchiveConfirmationDialog() {
        this.archivingConfirmation = new MoveToArchivedConfirmationDialog({
            canEditTaskStatus: this.state.canEditTaskStatus,
            confirmCallback: ({customer, project, withRestore, workflowStatusId}) => {
                this.archivingConfirmation.hide()
                const moveType = withRestore ? BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_RESTORE : BulkMoveTypes.OPEN_TO_ARCHIVED_WITH_COMPLETION
                this.actions.moveTasksAction(customer, project, moveType, workflowStatusId)
            },
            cancelCallback: () => {
                this.archivingConfirmation.hide()
                const moveToDialogState = this.moveToDialog.getState()
                this.moveToDialog.show()
                this.moveToDialog.setState(moveToDialogState)
            },
            initStatusMenuTo: $('body'),
        }).init(this.moveTasksDialog.getEl().find(".content"))
        this.archivingConfirmation.setState({
            workflowStatusId: this.state.defaultCompletedStatus.id,
            withRestoreOption: true,
            title: messageResource.getMessage("task.list.move_to.bulk.confirm_archive.title"),
            singleOptionDescription: messageResource.getMessage("task.list.move_to.bulk.confirm_archive.description.single_option"),
            multiOptionDescription: messageResource.getMessage("task.list.move_to.bulk.confirm_archive.description.multi_option"),
            archiveText: this.state.isTWSEnabled
                ? messageResource.getMessage('task.list.move_to.bulk.confirm_archive.complete_with_status')
                : messageResource.getMessage('task.list.move_to.bulk.confirm_archive.complete_feature_disabled'),
            restoreText: messageResource.getMessage("task.list.move_to.bulk.confirm_archive.restore.project"),
        })
        this.archivingConfirmation.hide()
    }

    _handleMoveTo = (customer, project) => {
        if (project.archived && this.state.moveDialogData.includeOpenTasks) {
            this.moveToDialog.hide()

            const canRestore = customer.archived ? !!this.state.editableCustomersIds[customer.id] : !!this.state.editableProjectsIds[project.id]
            this.archivingConfirmation.setState({
                customer: customer,
                project: project,
                withRestoreOption: canRestore,
                completeOptionSelected: true,
                workflowStatusId: this.state.defaultCompletedStatus.id,
                showRestoreNote: customer.archived && project.archived,
            })
            this.archivingConfirmation.show()
        } else {
            const moveType = project.archived ? BulkMoveTypes.ARCHIVED_TO_ARCHIVED : BulkMoveTypes.TO_OPEN
            this.actions.moveTasksAction(customer, project, moveType, null)
        }
    }

    _initCopyTasksDialog() {
        this.copySettingsBlock = new CopySettingsBlock({
            ...getItemsForCopyTaskSettingsBlock(this.state.canManageAccountsAndPermissions,
                this.state.isBTYEnabled,
                this.state.isESTEnabled,
                this.state.isTWSEnabled,
                this.state.isWASEnabled,
                this.state.hasSomeTeamAssignment
            )
        })

        this.copyTasksDialogInfoBlock = new InformationBlock()

        this.copyToDialog = new MoveToDialog({
            mode: MoveToDialog.Mode.CUSTOMER_PROJECT,
            titleMessageKey: "task.list.copy_to.task.title",
            buttonMessageKey: "edit_panel.action.copy",
            onMoveCb: (customer, project, settings) => this.actions.copyTasksAction(this.state.copyDialogTaskIds, project.id, settings),
            onCancelCb: () => this.copyTasksDialog.hide(),
            infoBlock: this.copyTasksDialogInfoBlock,
            settingsBlock: this.copySettingsBlock,
        })

        this.copyTasksDialog = new DialogWithPointerWrapper(
            this.params.$dialogsContainerEl,
            this.params.$pageEl,
            {
                className: 'copyDialog',
                dialog: this.copyToDialog,
                dialogType: BulkOperationType.COPY,
            }
        ).init()
    }

    _updateDialogsInfo() {
        this.moveTaskDialogInfoBlock.setState({
            paragraphs: [
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph1'
                                                                   : 'task.list.move_to.task.info_paragraph1_was_off'),
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.move_to.task.info_paragraph2'
                                                                   : 'task.list.move_to.task.info_paragraph2_was_off'),
            ],
        })

        this.copyTasksDialogInfoBlock.setState({
            paragraphs: [
                messageResource.getMessage(this.state.isWASEnabled ? 'task.list.copy_to.bulk.info_paragraph'
                                                                   : 'task.list.copy_to.bulk.info_paragraph_was_off'),
            ],
        })
    }

    _handleOnDeleteClick = ($btn) => {
        this.actions.startBulkTasksDeleteAction(() => {
            this.deleteTasksDialog.setState({
                ...this.state.deleteDialogData,
                saving: false,
            })
            this.deleteTasksDialog.show($btn)
        })
    }

    _handleOnChangeStatusClick = ($btn) => {
        this.actions.startBulkChangeTasksStatusAction(() => {
            this.changeTasksStatusDialog.setState({
                ...this.state.changeStatusDialogData,
                selectedWorkflowStatusId: this.state.changeStatusDialogData.defaultWorkflowStatusId,
                saving: false,
            })
            this.changeTasksStatusDialog.show($btn)
        })
    }

    _handleOnAssignToClick = ($btn) => {
        this.actions.startBulkAssignAction(() => {
            this.assignToDialog.setState({
                ...this.state.assignToDialogData,
                saving: false,
            })
            this.assignToDialog.show($btn)
        })
    }

    _handleOnMoveToClick = ($btn) => {
        this.actions.startBulkMoveAction(() => {
            this._updateMoveToDialogData()
            this.moveTasksDialog.show($btn)
        })
    }

    _handleOnCopyToClick = ($btn) => {
        this.actions.startBulkCopyOperation()
        this._updateCopyToDialogData()
        this.copyTasksDialog.show($btn)
    }

    _toggleOnEscHandler = (install = false) => {
        if (this.onKeyDownRemover) this.onKeyDownRemover()

        if (install) {
            this.onKeyDownRemover = KEY_HANDLERS.onKeyDown((e) => {
                if (isEsc(e)) {
                    this._handleEscOnPanel()
                    return true
                }
            })
        }
    }

    _handleEscOnPanel = () => {
        this.actions.clearTaskSelectionAction()
        this.archivingConfirmation.hide()
    }

    _updateMoveToDialogData() {
        this.archivingConfirmation.hide()
        this.moveToDialog.setLoading(this.state.moveDialogData.loading)
        const numberOfTasks = this.state.moveDialogData.taskIds.length
        this.moveToDialog.updateTitle(numberOfTasks === 1
                                      ? messageResource.getMessage("task.list.move_to.bulk.title.move_task")
                                      : messageResource.getMessage("task.list.move_to.bulk.title.move_tasks", [numberOfTasks])
        )
        this.moveToDialog.updateNotAvailableTasks(this.state.moveDialogData.notAvailableToMoveTasks)
    }

    _updateCopyToDialogData() {
        const numberOfTasks = this.state.copyDialogTaskIds.length
        this.copyToDialog.updateTitle(numberOfTasks === 1
            ? messageResource.getMessage("task.list.copy_to.bulk.title.copy_task")
            : messageResource.getMessage("task.list.copy_to.bulk.title.copy_tasks", [numberOfTasks])
        )
    }

    _handleOperationDialogs = (state, prevState) => {
        const {currentOperation} = state
        const prevOperation = prevState.currentOperation

        if (currentOperation !== null) {
            if (currentOperation === BulkOperationType.DELETE) {
                this.deleteTasksDialog.setState({
                    ...state.deleteDialogData,
                    saving: state.operationProcessing,
                })
            }
            if (currentOperation === BulkOperationType.CHANGE_ASSIGNMENTS) {
                this.assignToDialog.setState({
                    ...state.assignToDialogData,
                    saving: state.operationProcessing,
                    loggedInUserId: state.loggedInUserId,
                })
            }
            if (currentOperation === BulkOperationType.CHANGE_STATUS) {
                this.changeTasksStatusDialog.setState({
                    ...state.changeStatusDialogData,
                    saving: state.operationProcessing,
                })
            }
            if (currentOperation === BulkOperationType.MOVE) {
                this._updateMoveToDialogData()
            }
            if (currentOperation === BulkOperationType.COPY) {
                this._updateCopyToDialogData()
            }
        } else {
            if (prevOperation === BulkOperationType.DELETE) {
                this.deleteTasksDialog.hide()
            }
            if (prevOperation === BulkOperationType.CHANGE_ASSIGNMENTS) {
                this.assignToDialog.hide()
            }
            if (prevOperation === BulkOperationType.CHANGE_STATUS) {
                this.changeTasksStatusDialog.hide()
            }
            if (prevOperation === BulkOperationType.MOVE) {
                this.moveTasksDialog.hide()
            }
            if (prevOperation === BulkOperationType.COPY) {
                this.copyTasksDialog.hide()
            }
        }
    }
}

export default connect(
    state => {
        return {
            ...getBulkOperationsPanelState(state),
            showPanel: isShowPanel(state),
            operationProcessing: isProcessingBulkOperation(state),
            deleteDialogData: getBulkTaskDeleteDialogData(state),
            currentOperation: getCurrentOperation(state),
            assignToDialogData: getBulkAssignDialogData(state),
            moveDialogData: getBulkMoveDialogData(state),
            copyDialogTaskIds: getSelectedTaskIdsArray(state),
            changeStatusDialogData: getBulkChangeStatusDialogData(state),
            recentlyCreatedTaskIds: getRecentlyCreatedTaskIds(state),
            moveAndCopySelectorsCustomerIds: getCustomerIdsWhereCanManageLeastOneProject(state),
            moveAndCopySelectorsProjectIds: getEditableProjectIdsWithExcludeSelf(state),
            noTeamAccess: isViewerHasNoTeamAccess(state),
            loggedInUserId: getLoggedInUserId(state),
            isWASEnabled: isWASEnabled(state),
            isBTYEnabled: isBTYEnabled(state),
            isTWSEnabled: isTWSEnabled(state),
            isESTEnabled: isESTEnabled(state),
            canManageAccountsAndPermissions: canManageAccountsAndPermissions(state),
            canEditTaskStatus: canViewerEditTaskStatus(state),
            hasSomeTeamAssignment: canAccessSomeTeamAssignment(state),
            editableCustomersIds: getEditableCustomerIds(state),
            editableProjectsIds: getEditableProjectIds(state),
            defaultCompletedStatus: getFirstCompletedWorkflowStatus(state)
        }
    },
    dispatch => {
        return {
            clearTaskSelectionAction: bindActionCreators(clearTaskSelectionAction, dispatch),
            loadExistingTaskIdsCountAction: bindActionCreators(loadExistingTaskIdsAction, dispatch),
            startBulkTasksDeleteAction: bindActionCreators(startBulkTasksDeleteAction, dispatch),
            deleteTasksAction: bindActionCreators(deleteTasksAction, dispatch),
            startBulkMoveAction: bindActionCreators(startBulkMoveAction, dispatch),
            moveTasksAction: bindActionCreators(moveTasksAction, dispatch),
            startBulkCopyOperation: bindActionCreators(startBulkCopyOperation, dispatch),
            copyTasksAction: bindActionCreators(copyTasksAction, dispatch),
            startBulkAssignAction: bindActionCreators(startBulkAssignAction, dispatch),
            startBulkChangeTasksStatusAction: bindActionCreators(startBulkChangeTasksStatusAction, dispatch),
            changeTasksStatusAction: bindActionCreators(changeTasksStatusAction, dispatch),
            changeTasksAssignmentsAction: bindActionCreators(changeTasksAssignmentsAction, dispatch),
            cleanupDialogsDataAction: bindActionCreators(cleanupDialogsDataAction, dispatch),
            setBulkOperationsPanelShownStateAction: bindActionCreators(setBulkOperationsPanelShownState, dispatch),
            changeBulkAssignDialogSelection: bindActionCreators(changeBulkAssignDialogSelection, dispatch),
        }
    }
)(Container)


// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/Container.js